"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RedirectUrlHelper = /** @class */ (function () {
    function RedirectUrlHelper() {
    }
    RedirectUrlHelper.getUrlAfterAppIdPart = function (platformLocation) {
        // returns application identifier, for example /indicata/
        var baseHref = platformLocation.getBaseHrefFromDOM();
        var origin = window.location.origin;
        var redirectUrl = window.location.href.substr(origin.length);
        // returns redirect url without application identifier
        return redirectUrl.substr(baseHref.length - 1);
    };
    return RedirectUrlHelper;
}());
exports.RedirectUrlHelper = RedirectUrlHelper;
//# sourceMappingURL=redirect-url-helper.js.map